export * from './useGetApplicationsQuery';
